import Spinner from '~/components/LoadingIndicator/Spinner';

import { useEntryCondition } from '~/hooks';

import styles from './Entry.module.scss';

/**
 * @description - 앱 최초 실행 시 보여지는 페이지
 */
const Entry = ({ isAppTypeChecked = true }: { isAppTypeChecked?: boolean }) => {
  useEntryCondition({ isAppTypeChecked });

  return (
    <div className={styles['entry-container']}>
      <Spinner />
    </div>
  );
};

export default Entry;
